export default __webpack_public_path__ + "static/madusha-61376790309ffa3d7e9d87f61ebf7c3d.jpeg";